import * as React from 'react';


/* Number of seconds per year */
const secondsPerYear: number = 31536000
/* How often the html updates the value (ms) */
const valueUpdateRate: number = 50


interface Props {
    stat: any;
}

export default class StatValue extends React.Component<Props> {
    state: any
    stat: any

    constructor(props) {
        super(props)
        this.state = { value: 0 }
        this.stat = props.stat
        this.tick = this.tick.bind(this)
    }
    
    componentDidMount() {
        const initalValue: number = getNextTick(this.stat);
        this.state = { value: initalValue }
        setInterval(() => this.tick(), valueUpdateRate);
    }

    tick() {
        const next = getNextTick(this.stat);
        this.setState({ value: next })
    }
    
    render() {
        return <p className="stat-value">{getDisplayString(this.state.value, this.stat.units)}</p>
    }
}

function getNextTick(stat: any): number {
    if(stat.type == "current") {
        const currentDate = Date.now()/1000
        const secondsSoFar = currentDate - stat.baseDate
        const perSecondGrowth = getPerSecondGrowth(stat.baseValue, stat.growthRate)
        const timeAdjustedBaseValue = stat.baseValue + (perSecondGrowth * secondsSoFar)
        return timeAdjustedBaseValue;
    } else if(stat.type == "counter") {
        const date = new Date()
        const secondsPerDay: number = 86400
        
        var percentOfTimeElapsed: number = 0.0
        if(stat.delimeter == "day") {
            percentOfTimeElapsed = (date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds() + date.getMilliseconds()/1000)/secondsPerDay
        } else if(stat.delimeter == "month") {
            //
        } else if(stat.delimeter == "year") {
            //
        }
        return stat.baseValue * percentOfTimeElapsed;
    }
    return 0;
}

function getPerSecondGrowth(value: number, growthRate: number): number {
    const estimatedGrowth = value * growthRate
    const perSecondGrowth = estimatedGrowth/((secondsPerYear/valueUpdateRate) * 1000)
    return perSecondGrowth;
}

function getDisplayString(value: number, units: string): string {
    var str = Math.round(value).toLocaleString("en-US")
    if (units != undefined) {
        str = ["$"].includes(units) ? (units + str) : (str + " " + units)
    }
    return str;
}